import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slant",
  "use": "icon-slant-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 22\" fill=\"none\" id=\"icon-slant\">\r\n<path d=\"M13.8868 19.2128C13.3587 20.8727 11.817 22 10.0751 22H0L6.11317 2.78719C6.64132 1.12727 8.18296 0 9.92487 0H20L13.8868 19.2128Z\" fill=\"#41B65A\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol